module.exports = __webpack_public_path__ + "aa2e59168ab4c8c99c6dcecfc1b6e46a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/giant-bow-red-s.png
// module id = 2822
// module chunks = 0